import { FC, CSSProperties } from 'react';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { WbBadge } from '../../WbBadge';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const RunningIcon: FC<Props> = ({ style, variant }) => {
  const classes = useStyles();

  return variant === 'reduced' ? (
    // The overflow:hidden wrapper clips the paint area of the rotating icon.
    // Without it, the corners of the 24×24 SVG extend ~5 px beyond its layout
    // box at 45° (diagonal ≈ 34 px), which triggers a scrollbar in any
    // ancestor with overflow:auto.
    <span
      style={{
        display: 'inline-flex',
        overflow: 'hidden',
      }}
    >
      <AutorenewIcon
        className={`${classes.icon} ${classes.animatedIcon}`}
        style={style}
      />
    </span>
  ) : (
    <WbBadge startIcon={<AutorenewIcon fontSize="small" />} color="accent">
      Running
    </WbBadge>
  );
};
